import axios from 'axios';
import { app } from '../config';

const HttpService = (function () {
    const API = axios.create({
        baseURL: '',
        timeout: 30000, // Timeout set to 30 seconds (30000 ms)
    });
    var service = {};
    const urls = app.urls;
    service.post = function (key, data) {
        return API.post(urls[key], data).then(res => {
            return res;
        }).catch(e => {
            console.log('ERROR:', e);
            checkNetorkError(e);
            return e.message
        });
    }

    service.postByURL = function (url, data, params) {
        return API.post(url, data, params).then(res => {
            return res.data;
        }).catch(e => {
            console.log('ERROR:', e);
            checkNetorkError(e);
            return e.message
        });
    }
    service.uploadChatFiles = async function (key, formData, params, config) {
        return await API.post(urls[key], formData, params, config).then(res => {
            return res;
        }).catch(e => {
            console.log('ERROR:', e);
            checkNetorkError(e);
            return e.message
        });
    }

    service.get = function (key, options) {
        return API.get(urls[key], { params: options })
            .then(res => {
                return res.data;
            }).catch(e => {
                return parseErrorResponse(e);
            });
    }

    service.getByUrl = function (url, options) {
        return API.get(url, { params: options })
            .then(res => {
                return res.data;
            }).catch(e => {
                return parseErrorResponse(e);
            });
    }


    service.postWithHeaders = function (key, data, headers, timeout = 30000) {
        return API.post(urls[key], data, { headers: headers, timeout: timeout }).then(res => {
            return res.data;
        }).catch(e => {
            console.log('ERROR:', e);
            checkNetorkError(e)
            return parseErrorResponse(e);
        });
    }

    service.getWithHeaders = function (key, options, headers) {
        return API.get(urls[key], { params: options, headers }).then(res => {
            return res.data;
        }).catch(e => {
            console.log('ERROR:', e);
            checkNetorkError(e)
            return e.message
        });
    }
    service.getURL = function (key) {
        return urls[key]
    }
    service.otpVerify = function (key, data, headers) {
        return API.get(urls[key], { params: data, headers }).then(res => {
            return res;
        }).catch(e => {
            console.log('ERROR:', e);
            checkNetorkError(e);
            return e.message
        });
    }
    function parseErrorResponse(error) {
        if (error.response) {
            if (error.response.status >= 500) {
                return 'Something went wrong. Please try again later.';
            }
            return error.response.data;
        }
        return error.message;
    }
    function isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }
    function checkNetorkError(error, type) {
        if (isJsonString(error) && error.toJSON().message === 'Network Error') {
            console.log(error)
        }
    }
    service.integrationService = function (url, method, headers, options) {
        const config = {
            method: method,
            url: url,
            params: method.toUpperCase() === 'GET' ? options : {},
            data: method.toUpperCase() !== 'GET' ? JSON.parse(options) : {},
            headers: headers
        };
        return API(config)
            .then(res => {
                return res.data;
            }).catch(e => {
                return parseErrorResponse(e);
            });
    }
    return service;
}());


export default HttpService;
